import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../../common_components/Header";
import DatePicker from "react-datepicker";
import Footer from "../../common_components/Footer";
import Drawer from "../../common_components/Drawer";
import {
    getUserHotelEnquiry_action,
    insertHotelEnquiry_action
} from "../../actions/exhibitor_module_actions/hotel_form_action/hotel_form_action";
import ExhibitorHeader from "../../common_components/exhibitor_module_header";
import ConfirmationModal from "../../common_components/confirmationa_modal";
import HeaderLogin from '../../common_components/HeaderLogin';
import { ToastContainer, toast } from "react-toastify";
import ExhibitorDrawer from "../../common_components/exhibitor_module_drawer";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../utils/withRouter";
import moment from "moment";
import Modal from "react-modal";
import Loader from "../../utils/Loader";
import {
    clearSessionStorage,
    countryActionId,
    stateActionId,
    cityActionId,
    pincodeActionId,
    verifyPrimaryEmailIDActionId,
    toastError, GSTvalidationActionId,
    toastSuccess, countryIWithCodeActionId
} from "../../utils/constants";
import Pagination from "../../utils/pagination";
import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from "../../actions/fillCombo_action";
import StepHeader from "./stepHeader";
import PrimaryChapter from "./primary_chapter";
import Description from "./description";
import Resizer from "react-image-file-resizer";
import {
    contactNoValidator,
    panNoValidator,
    tanNoValidator,
    gstNoValidator,
    emailValidator,
} from "../../utils/Validator";
import $ from "jquery";
import {
    getHotelDetails_action,
} from "../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/hotelEnquiry_action/hotelEnquiry_action";
import VisitorHeader2 from "../../common_components/visitor_module_header2";
import VisitorDrawer from "../../common_components/visitor_module_drawer";
import ExhibitorTopMenu from "../../common_components/exhibitor_module_topmenu";
import VisitorTopMenu from "../../common_components/visitor_module_topmenu";
/* 
 * mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
 * mapStateToProps getUserHotelEnquiry_action
insertHotelEnquiry_action
*/
const mapStateToProps = state => ({
    ...state
})

class HotelEnquiryForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            isDataLoad: false,
            isExibitionClosed: false,
            isregistrationLinkClosed: false,
            code: '',
            isOtherPreName: '',
            otherName: '',
            Name: '',
            NameErr: '',
            preName: 'Mr',
            companyName: '',
            companyNameErr: '',
            Email: '',
            EmailErr: '',
            mobNo: '',
            mobNoErr: '',
            preMobNo: '',
            remark: '',
            NOP: '',
            NOPErr: '',
            NOR: '',
            NORErr: '',
            checkInDate: '',
            checkOutDate: '',
            checkInDateErr: '',
            checkOutDateErr: '',
            singleOcc: '',
            doubleOcc: '',
            singleOccErr: '',
            doubleOccErr: '',
            from: '',
            exhID: '',
            EventDate: '',
            SetupDate: '',
            DismantleDate: '',
            ExhibitionAddress: '',
            HotelDetailsList: [],
            isOpen: false,
            RoleID: sessionStorage.getItem("RoleIDSS"),
        }
        this.getFillList = this.getFillList.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.inputValidation = this.inputValidation.bind(this)
        this.getDetails = this.getDetails.bind(this)
        this.onCancleForm = this.onCancleForm.bind(this)

        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.handleSubmit()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }
    componentDidMount() {
        const { isLoading, exhID, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr, from } = this.state
        var tempForm = this.props.location.state != null && this.props.location.state.from ? this.props.location.state.from : ''
        this.setState({
            from: this.props.location.state != null && this.props.location.state.from ? this.props.location.state.from : null,
            exhID: this.props.location.state != null && this.props.location.state.exhID ? this.props.location.state.exhID : null,
        }, () => {
            if (tempForm == "thanks") {
                this.getFillList(countryIWithCodeActionId, '', '', '', sessionStorage.getItem("sessionCode"), '')
            }
            this.getDetails()
            this.getHotelDetails()
            window.scrollTo(0, 0);
        })
    }

    getHotelDetails() {
        const { HotelDetailsList } = this.state
        this.setState({ isLoading: true })
        this.props
            .getHotelDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, HotelDetailsList: data.data })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getDetails() {
        const { isLoading, exhID, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, EventDate, DismantleDate, SetupDate, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr } = this.state        // this.setState({ isLoading: true })
        this.props
            .getUserHotelEnquiry_action(exhID) // DYNAMIC PARAMS HAS TO BE PLACE LATER <<==
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data[0][0])
                    var mobNo = data.data[0][0].MobileNo != '' && data.data[0][0].MobileNo != null ? data.data[0][0].MobileNo.split('-') : []
                    var preMob = mobNo.length == 2 ? mobNo[0] : ''
                    var mobNo1 = mobNo.length == 2 ? mobNo[1] : mobNo.length == 1 ? mobNo[0] : ''
                    this.setState({
                        Name: data.data[0][0].PersonIncharge,
                        companyName: data.data[0][0].CompanyName,
                        DismantleDate: data.data[0][0].DismantleDate,
                        EventDate: data.data[0][0].EventDate,
                        mobNo: mobNo1,
                        preMobNo: preMob,
                        Email: data.data[0][0].PrimaryEmail,
                        SetupDate: data.data[0][0].SetupDate,
                        ExhibitionAddress: data.data[0][0].ExhibitionAddress
                    })
                }
            }).catch(e => {
                console.log(e)
            })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
            .then((data) => {
                if (data.error != 1) {
                    if (actionID === countryIWithCodeActionId) {
                        if (data.data.length > 0) {
                            console.log("country data", data.data[0])
                            console.log(data.data[0])
                            var emailArr = data.data[0].ExhMailEmail != '' && data.data[0].ExhMailEmail != null ? data.data[0].ExhMailEmail.split(",") : []
                            var mobileArr = data.data[0].ExhMailMobile != '' && data.data[0].ExhMailMobile != null ? data.data[0].ExhMailMobile.split(",") : []

                            sessionStorage.setItem("sessionExhibitionID", data.data[0]['ExhibitionID'])
                            sessionStorage.setItem("exhibitionAddress", data.data[0]['Address'])
                            sessionStorage.setItem("sessionBannerPath", data.data[0]['Banner'])
                            sessionStorage.setItem("exhibitionDateFrom", data.data[0]['ExhibitionDateFrom'])
                            sessionStorage.setItem("exhibitionDateTo", data.data[0]['ExhibitionDateTo'])
                            sessionStorage.setItem("sessionLogoPath", data.data[0]['Logo'])
                            sessionStorage.setItem("sessionExhibitionName", data.data[0]['ExhibitionName'])
                            sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                            sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                            sessionStorage.setItem("sessionExhMailWebsite", data.data[0]['ExhMailWebsite'])

                            this.setState({
                                isDataLoad: true,
                                isExibitionClosed: data.data[0]['IsExhibitionClosed'] != null && data.data[0]['IsExhibitionClosed'] == 1 ? true : false,
                                isregistrationLinkClosed: data.data[0]['isregistrationLinkClosed'] != null && data.data[0]['isregistrationLinkClosed'] == 1 ? true : false,
                            })
                            console.log("country data", emailArr, mobileArr, JSON.parse(sessionStorage.getItem("sessionExhibitionMobileNo")))
                            this.setState({ isLoading: false })

                        } else {
                            this.setState({ isLoading: false, invalidLink: true })
                        }

                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    handleSubmit() {
        const { isLoading, exhID, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, checkInDate, checkInDateErr, checkOutDate, checkOutDateErr, code, NOP, NOPErr, NOR, NORErr, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, singleOcc, doubleOcc, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr } = this.state
        this.inputValidation().then(res => {
            if (!res) {
                if (NOR != (parseInt(doubleOcc) + parseInt(singleOcc))) {
                    toastError("No of rooms should be equal to sum of single occupancy and double occupancy")
                } else {
                    this.setState({ isLoading: true })
                    var finalMobNo = ''
                    if (preMobNo != '' && preMobNo != null) {
                        finalMobNo = `${preMobNo}-${mobNo}`
                    } else {
                        finalMobNo = mobNo
                    }
                    console.log(
                        Name,
                        companyName,
                        Email,
                        finalMobNo,
                        checkInDate,
                        checkOutDate,
                        NOP,
                        NOR,
                        singleOcc,
                        doubleOcc,
                        remark
                    )
                    this.props
                        .insertHotelEnquiry_action(exhID,
                            Name,
                            companyName,
                            Email,
                            finalMobNo,
                            checkInDate,
                            checkOutDate,
                            NOP,
                            NOR,
                            singleOcc,
                            doubleOcc,
                            remark)
                        .then((data) => {
                            if (data.error != 1) {
                                this.setState({ isLoading: false })
                                toastSuccess("Form Submitted Successfully")
                                setTimeout(() => {
                                    this.props.navigate(-1)
                                }, 1000);
                            }
                        }).catch((e) => {
                            console.log(e);
                        });
                }
            } else {
                toastError("Please fill mandatory fields")
            }
        })

    }

    inputValidation() {
        const { isLoading, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, singleOcc, doubleOcc, NOP, NOPErr, NOR, NORErr, singleOccErr, doubleOccErr, checkInDate, checkInDateErr, checkOutDate, checkOutDateErr, code, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr } = this.state
        return new Promise((resolve, reject) => {
            var Errr = false
            if (companyName.trim() == '' || companyName.trim() == null) {
                this.setState({ companyNameErr: "Please Enter Organization Name" })
                Errr = true
            }
            if (Name.trim() == '' || Name.trim() == null) {
                this.setState({ NameErr: "Please Enter Name" })
                Errr = true
            }
            if (Email.trim() == '' || Email.trim() == null) {
                this.setState({ EmailErr: "Please Enter Email" })
                Errr = true
            }
            if (mobNo.trim() == '' || mobNo.trim() == null) {
                this.setState({ mobNoErr: "Please Enter Mobile" })
                Errr = true
            }
            if (checkInDate == '' || checkInDate == null) {
                this.setState({ checkInDateErr: "Please Enter CheckIn date" })
                Errr = true
            }
            if (checkOutDate == '' || checkOutDate == null) {
                this.setState({ checkOutDateErr: "Please Enter CheckOut date" })
                Errr = true
            }
            if (NOP == '' || NOP == null) {
                this.setState({ NOPErr: "Please Enter No. of Pax" })
                Errr = true
            }
            if (NOR == '' || NOR == null) {
                this.setState({ NORErr: "Please Enter No. of Rooms" })
                Errr = true
            }
            if (singleOcc == '' || singleOcc == null) {
                this.setState({ singleOccErr: "Please Enter Single Occupancy" })
                Errr = true
            }
            if (doubleOcc == '' || doubleOcc == null) {
                this.setState({ doubleOccErr: "Please Enter Double Occupancy" })
                Errr = true
            }

            resolve(Errr)
        })
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }


    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    onCancleForm(e) {
        e.preventDefault()
        this.props.navigate(-1)
    }

    render() {
        const { isLoading, isDataLoad, isOpenConfirmationModal, singleOcc, singleOccErr, doubleOcc, doubleOccErr, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, preMobNo, checkInDate, tentativeDaysSetup, checkInDateErr, remark, tentativeDaysSetupErr, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, checkOutDate, checkOutDateErr, tentativeDaysEventErr, SetupDate, EventDate, DismantleDate, ExhibitionAddress, from, tentativePaxEvent, NOP, NOPErr, NOR, NORErr, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr, HotelDetailsList, isOpen, RoleID } = this.state
        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {isLoading ? <Loader></Loader> : null}
                <ToastContainer />
                <>
                    {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
                        <ExhibitorHeader />
                    ) : (
                        <VisitorHeader2 />
                    )}
                    {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
                        <ExhibitorDrawer />
                    ) :
                        <VisitorDrawer />
                    }

                    {/* PAGE */}
                    <div
                        className={"with-dr-container"}
                        style={{ marginTop: RoleID == 1 ? "50px" : "20px" }}
                    >
                        <div className="main-container">
                            <div className="row">
                                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                                    1 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                                    8 ? (
                                    <ExhibitorTopMenu />
                                ) : <VisitorTopMenu />}
                            </div>
                            {/* {from == 'dashboard' ? <ExhibitorHeader /> : isDataLoad ? <HeaderLogin /> : null}
                            {from == 'dashboard' ? <ExhibitorDrawer /> : null} */}

                            <div >
                                <div className="side-app">
                                    <>
                                        {!false ? (
                                            <>
                                                <div className="container-fluid mt-top-space p-0" >
                                                    <div className="row justify-content-center">
                                                        <div className="col-xl-12 col-lg-11 col-md-12">

                                                            <div className="card shadow-sm rounded-2">
                                                                <div className="card-body p-3">

                                                                    {/* Header */}
                                                                    <h3 className="text-center fw-bold mb-3">
                                                                        VENUE HOTEL ENQUIRY FORM FOR INDIA ITME 2026
                                                                    </h3>

                                                                    {/* Event Details */}
                                                                    <div className="row">
                                                                        <div className="col-md-6 mt-0">
                                                                            <p><strong>Setup Date :</strong> {SetupDate || ""}</p>
                                                                            <p><strong>Event Date :</strong> {EventDate || ""}</p>
                                                                            <p><strong>Dismantle Date :</strong> {DismantleDate || ""}</p>
                                                                            <p><strong>Venue :</strong> {ExhibitionAddress || ""}</p>
                                                                        </div>
                                                                        {HotelDetailsList[0]?.[0]?.['HotelName'] != "" && HotelDetailsList[0]?.[0]?.['HotelName'] != null &&
                                                                            <div className="col-md-6 mt-0">
                                                                                <p className="text-left m-0"><strong>Hotel Name :</strong> {HotelDetailsList[0]?.[0]?.['HotelName'] || ""}</p>
                                                                                <p className="text-left my-2"><strong>Address :</strong> {HotelDetailsList[0]?.[0]?.['HotelAddress'] || ""}</p>
                                                                                <p className="text-left mt-1 mb-0"><strong>Room Tariff (Per Day) :</strong></p>
                                                                                {HotelDetailsList[1]?.length && HotelDetailsList[1]?.map((item) => (
                                                                                    <>
                                                                                        <p className="text-left m-0">
                                                                                            <span > {item.Occupancy || ""}</span>
                                                                                        </p>
                                                                                    </>
                                                                                ))}
                                                                                <p className="text-left m-0">
                                                                                    <a
                                                                                        className="mt-2 custom-link"
                                                                                        onClick={(e) => this.setState({ isOpen: true })}
                                                                                    >
                                                                                        View Package Includes, Basic Facilities, Additional Amenities
                                                                                    </a>
                                                                                </p>
                                                                            </div>
                                                                        }
                                                                    </div>

                                                                    {/* <hr /> */}
                                                                    <div className="row">
                                                                        <p className="m-0">
                                                                            <strong>Not Included in the Hotel Package:</strong>
                                                                            <ol className="m-1" style={{ listStyleType: "1." }}>
                                                                                {HotelDetailsList[5]?.length > 0 &&
                                                                                    HotelDetailsList[5].map((item, index) => (
                                                                                        <li key={index}>
                                                                                            {item.Package || "-"}
                                                                                        </li>
                                                                                    ))}
                                                                            </ol>
                                                                        </p>
                                                                        <p className="m-0">
                                                                            <strong>Payment Terms:</strong>
                                                                            <ol className="m-1" style={{ listStyleType: "1." }}>
                                                                                {HotelDetailsList[6]?.length > 0 &&
                                                                                    HotelDetailsList[6].map((item, index) => (
                                                                                        <li key={index}>
                                                                                            {item.PaymentTerms || "-"}
                                                                                        </li>
                                                                                    ))}
                                                                            </ol>
                                                                        </p>
                                                                        <p >
                                                                            <strong>Disclaimer:</strong><br />
                                                                            <ol className="m-1 px-3" style={{ listStyleType: "none" }}>
                                                                                <li>
                                                                                    {HotelDetailsList[0]?.[0]?.['Disclaimer']}
                                                                                </li>
                                                                            </ol>
                                                                        </p>
                                                                    </div>
                                                                    {/* Personal Info */}
                                                                    <div className="row g-3">
                                                                        <div className="col-md-6 mt-0">
                                                                            <label className="form-label">
                                                                                Name <span className="text-danger">*</span>
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                value={Name}
                                                                                maxLength="50"
                                                                                onChange={(e) => this.setState({ Name: e.target.value, NameErr: "" })}
                                                                            />
                                                                            <span className="text-danger">{NameErr}</span>
                                                                        </div>

                                                                        <div className="col-md-6 mt-0">
                                                                            <label className="form-label">
                                                                                Organization <span className="text-danger">*</span>
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                value={companyName}
                                                                                maxLength="200"
                                                                                onChange={(e) => this.setState({ companyName: e.target.value, companyNameErr: "" })}
                                                                            />
                                                                            <span className="text-danger">{companyNameErr}</span>
                                                                        </div>

                                                                        <div className="col-md-6 mt-0">
                                                                            <label className="form-label">
                                                                                Email <span className="text-danger">*</span>
                                                                            </label>
                                                                            <input
                                                                                type="email"
                                                                                className="form-control"
                                                                                value={Email}
                                                                                onChange={(e) => this.setState({ Email: e.target.value, EmailErr: "" })}
                                                                            />
                                                                            <span className="text-danger">{EmailErr}</span>
                                                                        </div>

                                                                        {/* Mobile */}
                                                                        <div className="col-md-6 mt-0 position-relative">
                                                                            <label className="form-label">
                                                                                Mobile No <span className="text-danger">*</span>
                                                                            </label>

                                                                            <div className="phone-input-group">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control phone-code" autoComplete="off"
                                                                                    placeholder="ISD"
                                                                                    maxLength={'4'} value={preMobNo}
                                                                                    onChange={(e) => this.setState({ preMobNo: e.target.value })}
                                                                                />
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control phone-no"
                                                                                    value={mobNo}
                                                                                    maxLength="10"
                                                                                    onChange={(e) =>
                                                                                        /^[0-9]*$/.test(e.target.value)
                                                                                            ? this.setState({ mobNo: e.target.value, mobNoErr: "" })
                                                                                            : null
                                                                                    }
                                                                                />
                                                                            </div>

                                                                            <span className="text-danger">{mobNoErr}</span>
                                                                        </div>
                                                                    </div>

                                                                    {/* <hr className="my-3" /> */}

                                                                    {/* Dates */}
                                                                    <div className="row g-3">
                                                                        <div className="col-md-4">
                                                                            <label className="form-label">
                                                                                Check In Date <span className="text-danger">*</span>
                                                                            </label>
                                                                            <DatePicker
                                                                                selected={checkInDate}
                                                                                className="form-control"
                                                                                dateFormat="dd/MM/yyyy"
                                                                                onChange={(date) =>
                                                                                    this.setState({
                                                                                        checkInDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                        checkInDateErr: ""
                                                                                    })
                                                                                }
                                                                            />
                                                                            <span className="text-danger">{checkInDateErr}</span>
                                                                        </div>

                                                                        <div className="col-md-4">
                                                                            <label className="form-label">
                                                                                Check Out Date <span className="text-danger">*</span>
                                                                            </label>
                                                                            <DatePicker
                                                                                selected={checkOutDate}
                                                                                className="form-control"
                                                                                dateFormat="dd/MM/yyyy"
                                                                                onChange={(date) =>
                                                                                    this.setState({
                                                                                        checkOutDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                        checkOutDateErr: ""
                                                                                    })
                                                                                }
                                                                            />
                                                                            <span className="text-danger">{checkOutDateErr}</span>
                                                                        </div>

                                                                        <div className="col-md-4">
                                                                            <label className="form-label">
                                                                                No. of Pax <span className="text-danger">*</span>
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                value={NOP}
                                                                                onChange={(e) =>
                                                                                    /^[0-9]*$/.test(e.target.value)
                                                                                        ? this.setState({ NOP: e.target.value, NOPErr: "" })
                                                                                        : null
                                                                                }
                                                                            />
                                                                            <span className="text-danger">{NOPErr}</span>
                                                                        </div>
                                                                    </div>

                                                                    {/* <hr className="my-3" /> */}

                                                                    {/* Rooms */}
                                                                    <div className="row g-3">
                                                                        <div className="col-md-4">
                                                                            <label className="form-label">
                                                                                Total Rooms <span className="text-danger">*</span>
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                value={NOR}
                                                                                onChange={(e) => this.setState({ NOR: e.target.value })}
                                                                            />
                                                                            <span className="text-danger">{NORErr}</span>
                                                                        </div>

                                                                        <div className="col-md-4">
                                                                            <label className="form-label">Single Occupancy<span className="text-danger">*</span></label>
                                                                            <input type="text" className="form-control" value={singleOcc} onChange={(e) => this.setState({ singleOcc: e.target.value, singleOccErr: '' })} />
                                                                            <span className="text-danger">{singleOccErr}</span>
                                                                        </div>

                                                                        <div className="col-md-4">
                                                                            <label className="form-label">Double Occupancy<span className="text-danger">*</span></label>
                                                                            <input type="text" className="form-control" value={doubleOcc} onChange={(e) => this.setState({ doubleOcc: e.target.value, doubleOccErr: '' })} />
                                                                            <span className="text-danger">{doubleOccErr}</span>
                                                                        </div>
                                                                    </div>

                                                                    {/* Comment */}
                                                                    <div className="mt-2">
                                                                        <label className="form-label">Comment</label>
                                                                        <textarea
                                                                            className="form-control"
                                                                            rows="4"
                                                                            value={remark}
                                                                            onChange={(e) => this.setState({ remark: e.target.value })}
                                                                        />
                                                                    </div>

                                                                    {/* Buttons */}
                                                                    <div className="d-flex justify-content-end gap-2 mt-3">
                                                                        <button className="btn btn-aqua px-4"
                                                                            //  onClick={this.handleSubmit}
                                                                            onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 0 }, popArg: [] })}
                                                                        >
                                                                            Submit
                                                                        </button>
                                                                        <button className="btn btn-gray px-4" onClick={this.onCancleForm}>
                                                                            Back
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                            </>
                                        ) : (
                                            <div
                                                className="main-content app-content mt-0"
                                                style={{ backgroundColor: "#ececec" }}
                                            >
                                                <div className="side-app">
                                                    <div className="main-container container-fluid top-form-name">
                                                        <div className="row ">
                                                            <form className="needs-validation " noValidate="">
                                                                <div className="form-row mt-4">
                                                                    <div className="form-group col-md-7 p-4 thank-box">
                                                                        <div className="form-group mb-2">
                                                                            <h4
                                                                                className="mb-0 pt-2 pb-4 thank-top-mes"
                                                                                style={{ color: "#318958" }}
                                                                            >
                                                                                <strong>Exhibition Closed</strong>
                                                                            </h4>
                                                                            <p className="mb-1 mt-1 text-center com-font">
                                                                                Thank you for your interest but the
                                                                            </p>
                                                                            <p className="mt-1 mb-0 text-center com-font">
                                                                                {sessionStorage.getItem("sessionExhibitionName")} from {moment(sessionStorage.getItem("exhibitionDateFrom")).format("DD MMMM YYYY")} to {moment(sessionStorage.getItem("exhibitionDateTo")).format("DD MMMM YYYY")}
                                                                            </p>
                                                                            <p className="mb-3 text-center com-font">
                                                                                at {sessionStorage.getItem("exhibitionAddress")} is now closed.
                                                                            </p>
                                                                            <p className="mb-3 text-center com-font">
                                                                                This Event already completed. Please Visit Again once the next edition is announced.
                                                                            </p>
                                                                        </div>
                                                                        <div classname="">
                                                                            <div classname="mt-1 mb-4">

                                                                                <button
                                                                                    classname="btn btn-aqua"
                                                                                    style={{
                                                                                        background: "#007bff",
                                                                                        padding: "6px 20px",
                                                                                        fontSize: 14,
                                                                                        border: "1px solid #007bff",
                                                                                        borderRadius: 2,
                                                                                        color: "#fff",
                                                                                        marginTop: 16
                                                                                    }}
                                                                                    onClick={e => this.onPreviousClick(e)}
                                                                                >
                                                                                    {" "}
                                                                                    BACK TO EVENT WEBSITE
                                                                                </button>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content shadow-lg border-0 rounded-4">
                            <div className="modal-header bg-aqua text-white py-2">
                                <h5 class="modal-title modal_title_text">Package Details</h5>
                                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isOpen: false })} ></button>
                            </div>
                            <div class="modal-body">
                                <p className="m-1">
                                    <strong>Package Includes:</strong>
                                    <ul className="m-1" style={{ listStyleType: "disc" }}>
                                        {HotelDetailsList[2]?.length > 0 &&
                                            HotelDetailsList[2].map((item, index) => (
                                                <li key={index}>
                                                    {item.Package || "-"}
                                                </li>
                                            ))}
                                    </ul>
                                </p>
                                <p className="m-1">
                                    <strong>Basic Facilities:</strong>
                                    <ul className="m-1" style={{ listStyleType: "disc" }}>
                                        {HotelDetailsList[3]?.length > 0 &&
                                            HotelDetailsList[3].map((item, index) => (
                                                <li key={index}>
                                                    {item.BasicFacility || "-"}
                                                </li>
                                            ))}
                                    </ul>
                                </p>
                                <p className="m-1">
                                    <strong>Additional Amenities:</strong>
                                    <ul className="m-1" style={{ listStyleType: "disc" }}>
                                        {HotelDetailsList[4]?.length > 0 &&
                                            HotelDetailsList[4].map((item, index) => (
                                                <li key={index}>
                                                    {item.AdditionalAmenities || "-"}
                                                </li>
                                            ))}
                                    </ul>
                                </p>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </>
        )
    }

}


export default withRouter(connect(null, {
    fill_action, getUserHotelEnquiry_action,
    insertHotelEnquiry_action, getHotelDetails_action
})(HotelEnquiryForm));